import { render } from "./logsEdit.vue?vue&type=template&id=65d38b57&scoped=true"
import script from "./logsEdit.vue?vue&type=script&lang=js"
export * from "./logsEdit.vue?vue&type=script&lang=js"

import "./logsEdit.vue?vue&type=style&index=0&id=65d38b57&lang=scss&scoped=true"
import "./logsEdit.vue?vue&type=style&index=1&id=65d38b57&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d38b57"]])

export default __exports__